import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Button,
    Flex,
    SimpleGrid,
    Stack,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
    useColorModeValue,
} from '@chakra-ui/react';
import { useAds } from 'contexts/AdsContext';
import { isValidUrl } from 'helpers/helper';
import CInput from 'components/CInput';
import CButton from 'components/CButton';
import ImageUpload from 'components/ImageUpload';

export default function NewAds() {
    const { getSingleAds, createAds, updateAds } = useAds();

    const navigate = useNavigate();
    const params = useParams();

    const textColor = useColorModeValue('secondaryGray.900', 'white');

    const [validated, setValidated] = useState(false);
    const [isImageValid, setIsImageValid] = useState(true);
    const [adsDetail, setAdsDetail] = useState({
        title: "",
        description: "",
        image: "",
        url: "",
        is_active: 1,
    });

    useEffect(() => {
        fetchSingleAd();

        return () => {
            setAdsDetail({
                title: "",
                description: "",
                image: "",
                url: "",
                is_active: 1,
            })
        }
    }, [params.id]);

    const fetchSingleAd = async () => {
        if (params.id) {
            const ad = await getSingleAds(params.id);
            if (ad) {
                setAdsDetail(ad);
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setValidated(true);

        if (!adsDetail?.title?.trim() || !adsDetail?.url?.trim() || !adsDetail.image || !isImageValid || !isValidUrl(adsDetail.url)) return;

        try {
            const formData = new FormData();
            formData.append('title', adsDetail.title);
            formData.append('description', adsDetail.description ? adsDetail.description.trim() : null);
            formData.append('url', adsDetail.url);
            formData.append('image', adsDetail.image);
            formData.append('is_active', adsDetail.is_active ? 1 : 0);

            if (params.id) {
                const data = await updateAds(params.id, formData);
                if (!data.error) {
                    navigate('/admin/ads');
                }
            } else {
                const data = await createAds(formData);
                if (!data.error) {
                    navigate('/admin/ads');
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Flex
            direction="column"
            minH="100vh"
            align="start"
            top="0"
            pt={{ sm: '125px', lg: '75px' }}
            position="relative"
            w="100%"
        >
            <Tabs w="100%">
                <TabPanels mt="24px" maxW="100%" w="100%" mx="auto">
                    <TabPanel w="100%" p="0px" mx="auto">
                        <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                            Ads Info
                        </Text>
                        <form onSubmit={handleSubmit}>
                            <Flex direction="column" w="100%">
                                <Stack direction="column" spacing="20px">
                                    <SimpleGrid
                                        columns={{ base: 1, md: 2 }}
                                        gap="20px"
                                        w="100%"
                                        templateColumns={{ md: "1fr 1fr" }}
                                    >
                                        <div>
                                            <CInput
                                                label="Title"
                                                type="text"
                                                value={adsDetail.title}
                                                onChange={(value) => setAdsDetail({ ...adsDetail, title: value })}
                                                required={true}
                                                validated={validated}
                                                placeholder="Enter Title"
                                                w="100%"
                                            />
                                            <CInput
                                                label="URL"
                                                type="text"
                                                value={adsDetail.url}
                                                onChange={(value) => setAdsDetail({ ...adsDetail, url: value })}
                                                required={true}
                                                validated={validated}
                                                validationRules={{ url: true }}
                                                placeholder="Enter URL"
                                                w="100%"
                                                mb="8px !important"
                                            />
                                        </div>
                                        <CInput
                                            label="Description"
                                            type="textarea"
                                            value={adsDetail.description}
                                            onChange={(value) => setAdsDetail({ ...adsDetail, description: value })}
                                            validated={validated}
                                            placeholder="Enter Description"
                                            w="100%"
                                            mb="8px !important"
                                        />
                                        <div>
                                            <CInput
                                                label="Active"
                                                type="switch"
                                                colorScheme="orange"
                                                value={adsDetail.is_active}
                                                onChange={(value) =>
                                                    setAdsDetail({
                                                        ...adsDetail,
                                                        is_active: value,
                                                    })
                                                }
                                                validated={validated}
                                                w="100%"
                                            />
                                            <ImageUpload
                                                label="Banner"
                                                existingImage={adsDetail.image && adsDetail.image instanceof File ? URL.createObjectURL(adsDetail.image) : adsDetail.image}
                                                onImageSelect={(file) => setAdsDetail({ ...adsDetail, image: file })}
                                                validateDimensions={true}
                                                setIsImageValid={setIsImageValid}
                                                validated={validated}
                                                setValidated={setValidated}
                                                required={true}
                                                fixWidth={320}
                                                fixHeight={65}
                                            />
                                        </div>
                                    </SimpleGrid>
                                </Stack>

                                <Flex justify="flex-end" align="center" mt="44px" gap="3">
                                    <Button
                                        variant="darkBrand"
                                        fontSize="sm"
                                        borderRadius="10px"
                                        w={{ base: '128px', md: '148px' }}
                                        h="46px"
                                        type="button"
                                        bg="gray"
                                        color="white"
                                        _hover={{ bg: 'gray.600' }}
                                        onClick={() => navigate('/admin/ads')}
                                    >
                                        Cancel
                                    </Button>
                                    <CButton
                                        w={{ base: '128px', md: '148px' }}
                                        h="46px"
                                        type="submit"
                                    >
                                        Submit
                                    </CButton>
                                </Flex>
                            </Flex>
                        </form>
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Flex>
    );
}